module.exports = __webpack_public_path__ + "static/media/ff_planner.58bfcb97.png";